import { AvaliacaoInput, ProblemasCondicoesInput } from 'graphql/types.generated'

import { AvaliacaoFormModel } from './AvaliacaoForm'

export const convertAvaliacaoFormToInput = (form: AvaliacaoFormModel): AvaliacaoInput => ({
  texto: form.texto,
  problemasCondicoesAvaliadas: form.condicoes?.map(
    (condicao) =>
      ({
        ciapId: condicao.ciap?.id,
        cidId: condicao.cid?.id,
        incluirListaProblemas: condicao.incluirNaListaProblemas,
        situacao: condicao.situacaoProblema,
        dataInicio: condicao.dataInicio?.data,
        dataFim: condicao.dataFim?.data,
        observacao: condicao.observacao,
        problemaCondicaoEvoluirId: condicao.problemaCondicaoEvoluir?.id,
      } as ProblemasCondicoesInput)
  ),
  vigilanciaSaudeBucal:
    form.tiposVigilancia && form.necessidadeProtese
      ? {
          necessidadeProtese: form.necessidadeProtese && JSON.parse(form.necessidadeProtese),
          tiposVigilancia: form.tiposVigilancia,
        }
      : null,
})
